export default __webpack_public_path__ + "static/media/wheel.2af9f257.webp";